###
# Параметры:
#   - text
###
App.SmValidationComponent = Em.Component.extend
  classNames: 'sm-validation'
  tagName: 'div'

  classNameBindings: ['isShown']

  isShown: (->
    return @get('text')?
  ).property('text')

  onTextChanged: (->
    return @set('internalText', @get('text')) if @get('text')?
    Em.run.debounce(@, ->
      return if @get('isDestroyed') or @get('isDestroying')
      @set('internalText', '')
    , 100)
  ).observes('text').on('init')

  internalText: ''
